var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPentanquebane(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "5.5mm",
    height: "5.5mm",
    viewBox: "0 0 15.591 15.591",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 15.591,
    height: 15.591,
    rx: 7.795,
    fill: "#746d51"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M5.41,3.907a.892.892,0,1,0-.891-.891A.891.891,0,0,0,5.41,3.907Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.345,6.489,6.159,4.306a.434.434,0,0,0-.246-.079L4.6,4.149a.5.5,0,0,0-.266.059L2.293,5.358a.505.505,0,0,0-.236.571l.256,1.042c.059.217.167.364.393.364a.735.735,0,0,0,.128-.019.464.464,0,0,0,.285-.6L3.08,6.047l.826-.354.04-.02-.03.767V7.8l-.138.924.344,1.564s-.8,2.052-.8,2.092a.583.583,0,0,0,.069.3.481.481,0,0,0,.227.206.508.508,0,0,0,.373.03.547.547,0,0,0,.285-.2c.2-.256.878-1.482.878-1.482l.135-1.486L5.8,10.916s.075,1.691.085,1.73a.592.592,0,0,0,.157.266.52.52,0,0,0,.393.138.548.548,0,0,0,.345-.177c.039-.04.171-2.469.171-2.469L6.2,8.457l.029-.482.02-.158.039-.678.059-.8.05-.433,2.4,1.338a.5.5,0,0,0,.689-.138A.424.424,0,0,0,9.345,6.489Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.586,11.327a.863.863,0,1,0,.863.862A.862.862,0,0,0,11.586,11.327Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPentanquebane);
export default __webpack_public_path__ + "static/media/PENTANQUEBANE.b10f852c69d787570efa39f0c8d65c19.svg";
export { ForwardRef as ReactComponent };